import React, { useState } from 'react';
import { toast } from 'react-toastify';
import ModalShell from './ModalShell';
import ModalFormFooter from './ModalFormFooter';
import PasswordInput from '../PasswordInput';

const ResetPasswordModal = ({ isOpen, onRequestClose, userEmail, userId, setUserPassword }) => {
  const [email, setEmail] = useState(userEmail || '');
  const [newPassword, setNewPassword] = useState('');
  const [isValidPassword, setIsValidPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleResetPassword = async () => {
    setIsLoading(true);
    try {
      await setUserPassword(userId, newPassword);
      onRequestClose();
    } catch (error) {
      console.error('Failed to reset password:', error);
      toast.error('Failed to reset password. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setEmail(userEmail || '');
    setNewPassword('');
    onRequestClose();
  };

  const isDisabled = !isValidPassword;

  const footer = (
    <ModalFormFooter
      onCancel={handleClose}
      onSubmit={handleResetPassword}
      isLoading={isLoading}
      isDisabled={isDisabled}
      submitLabel="Set Password"
      loadingLabel="Setting..."
    />
  );

  return (
    <ModalShell isOpen={isOpen} onClose={handleClose} title="Reset Password" footer={footer} maxWidthClass="max-w-md">
      <label className="mb-2 hidden">
        Email:
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter user's email"
          className="w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
          disabled={!!userEmail}
        />
      </label>
      <label className="flex flex-col gap-2 mb-2">
        <p>New Password:</p>
        <PasswordInput
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="Enter new password"
          setIsValidPassword={setIsValidPassword}
          reset
        />
      </label>
    </ModalShell>
  );
};

export default ResetPasswordModal;
